<template>
  <View class="date-picker" align="center" gap="sm">
    <View
      direction="column"
      gap="sm"
      v-for="(monthKeyValue, monthKey, monthIndex) in generateDisplayedDays()"
      :key="monthIndex"
    >
      <Text variant="label-medium" class="month-title">{{ monthKey }}</Text>
      <View gap="sm">
        <div
          class="date-card"
          v-for="(day, dayIndex) in monthKeyValue"
          @click="selectDate(day.date)"
          :key="dayIndex"
          :class="{ selected: day.date.getTime() === model?.getTime() }"
        >
          <Text class="day" variant="body-small">{{ day.dayIndex }}</Text>
          <Text class="date" variant="h5">{{ day.monthDayIndex }}</Text>
        </div>
      </View>
    </View>
  </View>
</template>

<script setup lang="ts">
import Text from './text.vue';
import View from './view/view.vue';

const model = defineModel<Date | null>();

const generateDisplayedDays = (): any => {
  const days = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  const availableDaysGroupedByMonth: {
    [key: string]: {
      dayIndex: string;
      monthDayIndex: number;
      date: Date;
    }[];
  } = {};
  const nextFourWeeksInDays = 28;

  for (let i = 0; i < nextFourWeeksInDays; i++) {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + i);

    const monthName = date.toLocaleString('default', { month: 'long' });

    if (!availableDaysGroupedByMonth[monthName]) {
      availableDaysGroupedByMonth[monthName] = [];
    }

    availableDaysGroupedByMonth[monthName].push({
      dayIndex: days[date.getDay()],
      monthDayIndex: date.getDate(),
      date: date,
    });
  }

  return availableDaysGroupedByMonth;
};

function selectDate(date: Date) {
  model.value = date;
}
</script>

<style scoped lang="scss">
.date-picker {
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.date-card {
  border-radius: var(--t-border-radius-sm);
  padding: 0.5rem;
  cursor: pointer;
  width: 2.5rem;
  height: 3.5rem;
  border: 1px solid transparent;

  &.selected {
    background-color: var(--t-color-neutral-900);

    .day,
    .date {
      color: var(--t-color-neutral-white);
    }
  }

  &:hover {
    border: 1px solid var(--t-color-neutral-900);
  }
}
</style>
